export const DATE_FORMAT_API = 'YYYY-MM-DD';
export const DAY_FORMAT_SHORT = 'EEE';
export const MINUTES_SECONDS_FORMAT = 'mm:ss';
export const TIME_FORMAT_LONG = 'HH:mm:ss';
export const TIME_FORMAT_SHORT = 'HH:mm';
export const TIME_FORMAT_IN_MINUTES_LONG = 'mm:ss.S';
export const TIME_FORMAT_IN_MINUTES_FULL = 'mm:ss.SSS';
export const TIME_FORMAT_FULL = 'HH:mm:ss.S';
export const MONTH_SHORT_FORMAT = 'MMM';
export const LUXON_DATE_FORMAT_LONG = 'EEE dd/MMM/y';
export const LUXON_DATE_FORMAT_SHORT = 'dd/MMM/y';
export const LUXON_DATE_FORMAT_FULL = 'EEE dd/MMM/y HH:mm';
export const LUXON_DAY_FORMAT_SHORT = 'EEE';
export const LUXON_DAY_MONTH_FORMAT = 'dd MMM';
export const LUXON_MONTH_YEAR_FORMAT = 'MMMM-yyyy';
export const LUXON_YEAR_FORMAT = 'yyyy';
export const LUXON_DATE_TIME_FORMAT_API = 'yyyy-MM-dd HH:mm:ss';
export const LUXON_YEAR_MONTH_FORMAT = 'yyyy-MM';
export const TIME_FORMAT_IN_MINUTES_SHORT = 'm:ss.SSS';
